var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgCloseCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM3.13514 9C3.13514 12.2391 5.76092 14.8649 9 14.8649C12.2391 14.8649 14.8649 12.2391 14.8649 9C14.8649 5.76092 12.2391 3.13514 9 3.13514C5.76092 3.13514 3.13514 5.76092 3.13514 9ZM9.80266 9L11.6716 10.8689C11.8933 11.0906 11.8933 11.45 11.6716 11.6716C11.45 11.8933 11.0906 11.8933 10.8689 11.6716L9 9.80266L7.13106 11.6716C6.90941 11.8933 6.55005 11.8933 6.3284 11.6716C6.10675 11.45 6.10675 11.0906 6.3284 10.8689L8.19734 9L6.3284 7.13106C6.10675 6.90941 6.10675 6.55005 6.3284 6.3284C6.55005 6.10675 6.90941 6.10675 7.13106 6.3284L9 8.19734L10.8689 6.3284C11.0906 6.10675 11.45 6.10675 11.6716 6.3284C11.8933 6.55005 11.8933 6.90941 11.6716 7.13106L9.80266 9Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-circle.0aa19bec3007415ed55604d937e456f7.svg";